<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { useClassStore, useSignalRStore } from '../../stores';
import Modal from '../General/Modal.vue';
import { ClassStatus } from '../../types/class';
import Heading from '../General/Heading.vue';
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../configs/text';
import { utils } from '../../utils';

const classStore = useClassStore()
const signalr = useSignalRStore()
const modalShow = ref<boolean>(false)
let endingInterval: NodeJS.Timeout | null = null
let autoFinishInterval: NodeJS.Timeout | null = null
const expiredTimeFormat = computed<string>(() => {
    if (!classStore.selectedClassDetails?.expiredTime) return '';
    return utils.formatTimestampToTime(classStore.selectedClassDetails?.expiredTime)
})

watch(() => classStore.selectedClassDetails?.expiredTime, () => {
    if (endingInterval) {
        clearInterval(endingInterval)
    }
    if (autoFinishInterval) {
        clearInterval(autoFinishInterval)
    }

    const autoFinishDelayMs = 30 * 60 * 1000 // 30 mins
    const expiredTimeMs = (classStore.selectedClassDetails?.expiredTime || 0) * 1000
    if (!expiredTimeMs) return;

    endingInterval = setInterval(() => {
        const currentTimestampMs = Date.now()
        const durationAutoFinishMs = expiredTimeMs - currentTimestampMs
        const durationEndMs = durationAutoFinishMs - autoFinishDelayMs

        if (durationEndMs <= 0) {
            if (classStore.selectedClassDetails?.state === ClassStatus.on_going) {
                modalShow.value = true
            }
            if (endingInterval) {
                clearInterval(endingInterval)
            }
        }
    }, 1000)

    autoFinishInterval = setInterval(() => {
        const currentTimestampMs = Date.now()
        const durationAutoFinishMs = expiredTimeMs - currentTimestampMs

        if (durationAutoFinishMs <= 0) {
            if (classStore.selectedClassDetails?.state === ClassStatus.on_going) {
                // temp disable auto end classroom
                // signalr.endClassRoom()
                console.log(signalr.isConnected)
            }
            modalShow.value = false
            if (autoFinishInterval) {
                clearInterval(autoFinishInterval)
            }
        }
    }, 1000)
})

const { t } = useI18n()
</script>

<template>
    <Modal v-model="modalShow" :static="true" size="medium">
        <Heading alignment="center">{{ t(TEXT.attention_please) }}</Heading>
        <div class="text-center">{{ t(TEXT.the_allocated_time_for_the_class_has_ended) }}</div>
        <div class="text-center font-bold">
            {{ t(TEXT.the_class_will_automatically_close_at, { expired_time: expiredTimeFormat }) }}
        </div>
    </Modal>
</template>